import { useEffect } from 'react';

interface IUseMakeHeaderStickyParams {
  sticky?: boolean;
}

export const useMakeHeaderSticky = (params: IUseMakeHeaderStickyParams | void) => {
  const { sticky = true } = params || {};

  useEffect(() => {
    const headerElement = document.getElementById('header-root');
    if (!headerElement) {
      return;
    }

    if (sticky) {
      headerElement.setAttribute('style', 'position: sticky; top: 0; z-index: 30');
    } else {
      headerElement.removeAttribute('style');
    }
  }, [sticky]);
};

export const useHeaderHeight = () => {
  useEffect(() => {
    // Функция для обновления высоты хедера
    const updateHeaderHeight = () => {
      const headerElement = document.getElementById('header-root');
      if (headerElement) {
        const height = headerElement.getBoundingClientRect().height;
        // Устанавливаем CSS-переменную --header-height
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    };

    // Инициализация высоты при монтировании компонента
    updateHeaderHeight();

    // Используем ResizeObserver для отслеживания изменений размеров хедера
    const headerElement = document.getElementById('header-root');

    let resizeObserver: ResizeObserver | null = null;
    if (headerElement) {
      resizeObserver = new ResizeObserver(() => {
        updateHeaderHeight();
      });
      resizeObserver.observe(headerElement);
    }

    // Также добавляем прослушивание изменения размера окна
    window.addEventListener('resize', updateHeaderHeight);

    // Очистка при размонтировании компонента
    return () => {
      if (resizeObserver && headerElement) {
        resizeObserver.unobserve(headerElement);
        resizeObserver.disconnect();
      }
      window.removeEventListener('resize', updateHeaderHeight);
    };
  }, []);
};
